/**
 * Cómo se nombra una máquina en pantalla (F2, 26-09-2026): la misma línea en la
 * lista de Equipo, en el «⋯» de crear tarea y en el del registro manual.
 */
import type { TFunction } from "i18next";
import { equipmentLabel, equipmentRegime } from "@/lib/machinery/equipmentRules";
import type { CompanyEquipment } from "@/lib/machinery/equipmentApi";
import type { ApplicationChoiceOption } from "@/components/applicationContext/ApplicationChoiceSheet";

/** «ROMA ES-…», «Censo …», «Exenta de ROMA» o «Sin nº ROMA». */
export function equipmentNumberText(
  e: Pick<CompanyEquipment, "equipment_type" | "roma_number" | "census_reference">,
  t: TFunction,
): string {
  if (equipmentRegime(e.equipment_type) === "exenta") return t("applicationContext.machinery.regimeShort.exenta");
  if (e.roma_number) return `ROMA ${e.roma_number}`;
  if (e.census_reference) return t("applicationContext.machinery.censusShort", { n: e.census_reference });
  return t("applicationContext.machinery.noNumber");
}

/** Las máquinas como líneas del selector del «⋯». */
export function equipmentChoiceOptions(list: CompanyEquipment[], t: TFunction): ApplicationChoiceOption[] {
  return list.map((e) => ({
    id: e.id,
    label: equipmentLabel(e),
    detail: `${t(`applicationContext.machinery.types.${e.equipment_type}`)} · ${equipmentNumberText(e, t)}`,
  }));
}
